import { Box, useTheme } from '@mui/material';
import Image from 'next/image';
import useResponsive from '@/components/hooks/useResponsive';
import caregiverReview from '@/../public/greaterCare/howItWorks/caregiver-review.jpg';
import dog from '@/../public/greaterCare/howItWorks/dog.jpg';
import fatherBaby from '@/../public/greaterCare/howItWorks/father-baby.jpg';
import phone from '@/../public/greaterCare/howItWorks/phone.png';
import sillyGirl from '@/../public/greaterCare/howItWorks/silly-girl.jpg';

const Images = () => {
  const theme = useTheme();
  const { isMobile, isTablet, isDesktop } = useResponsive();

  return (
    <Box
      data-testid="how-it-works-images"
      sx={{
        width: { xs: '100%', sm: 'auto', md: '604px' },
        height: { xs: '360px', sm: '648px', md: '552px' },
        display: { xs: 'flex' },
        flexDirection: { sm: 'column' },
        justifyContent: { xs: 'center' },
        overflow: 'hidden',
      }}>
      {isMobile && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.background.secondary,
            overflow: 'hidden',
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              overflow: 'hidden',
            }}>
            <Box
              sx={{
                display: 'flex',
                overflow: 'hidden',
                position: 'relative',
                width: '247px',
                height: '178px',
                '& .silly-girl': {
                  objectFit: 'cover',
                  objectPosition: 'top',
                  borderRadius: '32px',
                },
              }}>
              <Image layout="fill" src={sillyGirl} className="silly-girl" />
            </Box>

            <Box
              sx={{
                display: 'flex',
                overflow: 'hidden',
                position: 'relative',
                width: '247px',
                height: '167px',
                mt: 3,
                '& .father-baby': {
                  objectFit: 'cover',
                  objectPosition: 'left',
                  borderRadius: '32px',
                },
              }}>
              <Image layout="fill" src={fatherBaby} className="father-baby" />
            </Box>
          </Box>

          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: theme.palette.brand.accent,
              padding: theme.spacing(4, 4, 0, 4),
              borderRadius: '32px 32px 0 0',
              height: '100%',
              width: '308px',
              ml: 3,
              '& .image': {
                objectFit: 'cover',
                objectPosition: 'top',
              },
            }}>
            <Image width="244px" height="357px" src={phone} className="image" />
          </Box>
        </Box>
      )}

      {isTablet && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.background.secondary,
            height: '100%',
            width: '280px',
          }}>
          <Box
            sx={{
              display: 'flex',
              position: 'relative',
              width: '315px',
              height: '193px',
              '& .dog': {
                objectFit: 'cover',
                objectPosition: 'center',
                borderRadius: '32px 0 0 0',
              },
            }}>
            <Image
              layout="fill"
              src={dog}
              className="dog"
              style={{
                borderBottomLeftRadius: '32px',
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              position: 'relative',
              backgroundColor: theme.palette.brand.accent,
              borderTopLeftRadius: '32px',
              pt: '36px',
              '& .image': {
                objectFit: 'cover',
                objectPosition: 'top 0 right -4px',
              },
            }}>
            <Image width="244px" height="384px" src={phone} className="image" />
          </Box>
        </Box>
      )}

      {isDesktop && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignSelf: 'normal',
            height: '100%',
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                backgroundColor: theme.palette.brand.accent,
                borderRadius: '0 0 32px 32px',
                pb: '22px',
              }}>
              <Image
                width="172px"
                height="173px"
                src={caregiverReview}
                style={{
                  borderRadius: '0 0 20px 20px',
                }}
              />
            </Box>

            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                '& .father-baby': {
                  objectFit: 'cover',
                  objectPosition: 'top',
                  borderRadius: '32px',
                },
              }}>
              <Image width="247px" height="151px" src={fatherBaby} className="father-baby" />
            </Box>

            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                '& .silly-girl': {
                  objectFit: 'cover',
                  objectPosition: 'top',
                  borderRadius: '32px 32px 0 0',
                },
              }}>
              <Image width="247px" height="140px" src={sillyGirl} className="silly-girl" />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                position: 'relative',
                display: 'flex',
                '& .dog': {
                  objectFit: 'cover',
                  objectPosition: 'center',
                  borderRadius: '0 0 32px 32px',
                },
              }}>
              <Image width="315px" height="135px" src={dog} className="dog" />
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                backgroundColor: theme.palette.brand.accent,
                borderRadius: '32px 32px 0 0',
                pt: '34px',
                '& .phone': {
                  objectFit: 'cover',
                  objectPosition: 'top',
                },
              }}>
              <Image width="244px" height="357px" src={phone} className="phone" />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Images;
